import React, { useEffect, useState } from "react";
import { fetchFounders, api } from "@/lib/api";
import { PROOF_WALL_MIN } from "@/components/ListenerStories";
import ProofWallCards from "@/components/ProofWallCards";

// Initial avatars for The First Listeners; named quote cards once enough stories are live.
export default function FirstListenersWall() {
  const [data, setData] = useState({ founders: [], total: 0 });
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/listener-stories").then((r) => setStories(r.data.stories || [])).catch(() => {});
    (async () => {
      try {
        const d = await fetchFounders();
        setData(d);
      } catch (e) {
        console.error("first listeners fetch failed", e);
      }
    })();
  }, []);

  const showCards = stories.length >= PROOF_WALL_MIN;
  if (!data.founders.length && !showCards) return null;

  return (
    <div
      className="mt-24 max-w-4xl border-t border-obsidian-600 pt-14"
      data-testid="first-listeners-wall"
    >
      <p className="font-sans uppercase tracking-[0.28em] text-xs text-terracotta mb-6">
        The First Listeners{!showCards && ` · ${data.total} listener${data.total === 1 ? "" : "s"} so far`}
      </p>
      <h2 className="font-serif text-2xl md:text-3xl text-bone-100 mb-8 leading-tight">
        {showCards ? <>In their own words, <em className="text-bone-300 italic">from the first to arrive.</em></> : <>A quiet circle of{" "}
        <em className="text-bone-300 italic">the first to arrive.</em></>}
      </h2>
      {showCards ? <ProofWallCards stories={stories} /> : (
      <div className="flex flex-wrap gap-4">
        {data.founders.map((f) => (
          <div
            key={f.number}
            className="h-14 w-14 rounded-full border border-terracotta/50 bg-obsidian-800 hover:border-terracotta flex items-center justify-center font-serif text-bone-100 hover:text-terracotta transition-colors relative group"
            title={`Listener №${f.number}`}
            data-testid={`first-listener-tile-${f.number}`}
          >
            <span className="text-lg">{f.initial}</span>
            <span className="absolute -bottom-5 font-sans text-[0.6rem] text-bone-500">
              №{f.number}
            </span>
          </div>
        ))}
      </div>
      )}
    </div>
  );
}
